// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"23":"6c0b9365aa919f817238","87":"93bc25947b0af2c409cd"}[chunkId] + ".css";
};